import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OtpService {
  private renderer: Renderer2;
  phone!: string;
  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadOtpWidget(): void {
    if (this.phone) {
      this.phone = '';
      const script = this.renderer.createElement('script');
      script.src =
        'https://control.msg91.com/app/assets/otp-provider/otp-provider.js';
      script.type = 'text/javascript';
      script.onload = () => this.initOtpWidget();
      this.renderer.appendChild(document.body, script);
    } else {
      const script = this.renderer.createElement('script');
      script.src =
        'https://control.msg91.com/app/assets/otp-provider/otp-provider.js';
      script.type = 'text/javascript';
      script.onload = () => this.initOtpWidget();
      this.renderer.appendChild(document.body, script);
    }
  }

  private initOtpWidget(): void {
    const configuration = {
      widgetId: environment.otpWidgetId,
      tokenAuth: environment.msg91AuthToken,
      identifier: this.phone,
      exposeMethods: true,
      success: (data: any) => {
        console.log('Otp widget loaded', data);
      },
      failure: (error: any) => {
        console.error('otp widget loading Failed:', error);
      },
    };

    if (typeof (window as any).initSendOTP === 'function') {
      (window as any).initSendOTP(configuration);
    } else {
      console.error('initSendOTP function is not available.');
    }
  }

  sendOtp(phoneNumber: string): void {
    this.phone = phoneNumber;
    if (typeof (window as any).sendOtp === 'function') {
      (window as any).sendOtp(phoneNumber);
    } else {
      console.error('sendOtp function is not available.');
    }
  }

  retryOtp(channel: string | null = null): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!(window as any).retryOtp) {
        reject('MSG91 retryOtp function not loaded');
        return;
      }

      (window as any).retryOtp(
        channel,
        (data: any) => resolve(data),
        (error: any) => reject(error)
      );
    });
  }

  verifyOtp(otp: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!(window as any).verifyOtp) {
        reject('MSG91 verifyOtp function not loaded');
        return;
      }

      (window as any).verifyOtp(
        otp,
        (data: any) => resolve(data),
        (error: any) => reject(error)
      );
    });
  }
}
